import React from "react";
import * as Icon from "react-feather";

import "./agent-source-icon.css";

const SOURCE_MARKS = {
	quickbooks: (
		<svg viewBox="0 0 24 24" aria-hidden="true">
			<circle cx="12" cy="12" r="11" fill="#2CA01C" />
			<circle cx="7.8" cy="12.2" r="3" fill="none" stroke="#fff" strokeWidth="1.7" />
			<line x1="10.8" y1="9.4" x2="10.8" y2="19" stroke="#fff" strokeWidth="1.7" strokeLinecap="round" />
			<circle cx="16.2" cy="11.8" r="3" fill="none" stroke="#fff" strokeWidth="1.7" />
			<line x1="13.2" y1="5" x2="13.2" y2="14.6" stroke="#fff" strokeWidth="1.7" strokeLinecap="round" />
		</svg>
	),
	google_drive: (
		<svg viewBox="0 0 24 24" aria-hidden="true">
			<path d="M7.7 3.5 1.2 15l3.4 6 6.6-11.5z" fill="#0F9D58" />
			<path d="M9.7 15 6.3 21h13.1l3.4-6z" fill="#4285F4" />
			<path d="M22.8 15 16.3 3.5H9.4L16 15z" fill="#FFC107" />
		</svg>
	),
	plaid: (
		<svg viewBox="0 0 24 24" aria-hidden="true">
			<rect x="1" y="1" width="22" height="22" rx="5" fill="#111111" />
			<rect x="6.2" y="6.2" width="4.4" height="4.4" rx="0.8" transform="rotate(45 8.4 8.4)" fill="#fff" />
			<rect x="13.4" y="6.2" width="4.4" height="4.4" rx="0.8" transform="rotate(45 15.6 8.4)" fill="#fff" />
			<rect x="6.2" y="13.4" width="4.4" height="4.4" rx="0.8" transform="rotate(45 8.4 15.6)" fill="#fff" />
			<rect x="13.4" y="13.4" width="4.4" height="4.4" rx="0.8" transform="rotate(45 15.6 15.6)" fill="#fff" />
		</svg>
	),
	gmail: (
		<svg viewBox="0 0 24 24" aria-hidden="true">
			<path d="M2 7.2V18a1.5 1.5 0 0 0 1.5 1.5H6V10.4z" fill="#4285F4" />
			<path d="M18 19.5h2.5A1.5 1.5 0 0 0 22 18V7.2l-4 3.2z" fill="#34A853" />
			<path d="M18 5.6v4.8l4-3.2V6.1a1.6 1.6 0 0 0-2.6-1.3z" fill="#FBBC04" />
			<path d="M6 10.4V5.6l6 4.6 6-4.6v4.8l-6 4.6z" fill="#EA4335" />
			<path d="M2 6.1v1.1l4 3.2V5.6L4.6 4.8A1.6 1.6 0 0 0 2 6.1z" fill="#C5221F" />
		</svg>
	),
	google_calendar: (
		<svg viewBox="0 0 24 24" aria-hidden="true">
			<rect x="2" y="2" width="20" height="20" rx="3" fill="#fff" stroke="#DADCE0" />
			<path d="M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v2.5H2z" fill="#4285F4" />
			<text x="12" y="18.2" textAnchor="middle" fontSize="9" fontWeight="700" fontFamily="Arial, sans-serif" fill="#1A73E8">
				31
			</text>
		</svg>
	),
};

class AgentSourceIcon extends React.PureComponent {
	render() {
		const { icon, size = "medium" } = this.props;
		const mark = SOURCE_MARKS[icon];

		return <span className={`agent-source-icon agent-source-icon--${size}`}>{mark || <Icon.MessageSquare className="agent-source-icon__feather" />}</span>;
	}
}

export default AgentSourceIcon;
